import { render } from "./PlansAdmin.vue?vue&type=template&id=5d9bf686&scoped=true"
import script from "./PlansAdmin.vue?vue&type=script&lang=js"
export * from "./PlansAdmin.vue?vue&type=script&lang=js"

import "./PlansAdmin.vue?vue&type=style&index=0&id=5d9bf686&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9bf686"]])

export default __exports__